export const CloserDetailScreenPath = "/closers/:closerId";

export function closerDetailPath(closerId: string): string {
  return CloserDetailScreenPath.replace(
    ":closerId",
    encodeURIComponent(closerId),
  );
}
